var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8094 15.7142V8.09519C13.8094 7.59002 13.6088 7.10553 13.2515 6.74832C12.8943 6.39111 12.4098 6.19043 11.9047 6.19043H4.28562C3.78045 6.19043 3.29596 6.39111 2.93875 6.74832C2.58154 7.10553 2.38086 7.59002 2.38086 8.09519V15.7142C2.38086 16.2194 2.58154 16.7039 2.93875 17.0611C3.29596 17.4183 3.78045 17.619 4.28562 17.619H11.9047C12.4098 17.619 12.8943 17.4183 13.2515 17.0611C13.6088 16.7039 13.8094 16.2194 13.8094 15.7142Z",
    stroke: "#00529C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8095 13.8095H15.7142C16.2194 13.8095 16.7039 13.6088 17.0611 13.2516C17.4183 12.8944 17.619 12.4099 17.619 11.9047V4.28855C17.619 3.78338 17.4183 3.29889 17.0611 2.94168C16.7039 2.58447 16.2194 2.38379 15.7142 2.38379H15.7114L8.09233 2.39712C7.58766 2.39788 7.10391 2.59889 6.74731 2.95602C6.39072 3.31315 6.19043 3.7972 6.19043 4.30188V6.19046",
    stroke: "#00529C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09521 9.04761V14.7619",
    stroke: "#00529C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9521 11.9048H5.23779",
    stroke: "#00529C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.94c2cf8d36590597620c877220d926f3.svg";
export { ForwardRef as ReactComponent };